// extracted by mini-css-extract-plugin
export default {"root":"CheckedCell_root__d7pzG"};